import { useRecord } from '../../../../../core/context/record-ctx';
import { Fragment } from '../../../types';

export function useFragmentCtx() {
  return useRecord<Fragment>();
}
